import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { IncentiveOfferOperationStatus } from 'modules/incentivesMarket/types';

import { statusBannerMap } from '../../../constants/incentiveOfferOperationStatus';

type IncentiveOfferOperationDetailStatusBannerProps = {
  operationStatus: IncentiveOfferOperationStatus;
  unitsCount: number;
  unitClassName: string;
};

const IncentiveOfferOperationDetailStatusBanner: FC<
  IncentiveOfferOperationDetailStatusBannerProps
> = ({ operationStatus, unitsCount, unitClassName }) => {
  const { t } = useTranslate();

  const statusBanner =
    statusBannerMap[operationStatus] || statusBannerMap.PENDING;

  return (
    <div className={`alert alert-icon ${statusBanner.className} mb-4`}>
      <em className={`icon ni ${statusBanner.icon}`} />
      <div>
        <h6 className="alert-heading">{t(statusBanner.heading)}</h6>
        <p className="mb-0">
          {t(statusBanner.message, {
            shares: unitsCount,
            className: unitClassName,
          })}
        </p>
      </div>
    </div>
  );
};

export default IncentiveOfferOperationDetailStatusBanner;
